function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import 'cross-fetch/polyfill';
import * as ACTION_TYPES from '@engine/actions/action-types';
/**
 * Action Creators for Risk Filter Settings
 */
// Get the Settings

export var requestFilterSettings = function requestFilterSettings() {
  return {
    type: ACTION_TYPES.RISK_FILTER_SETTINGS_REQUEST
  };
};
export var receivedFilterSettings = function receivedFilterSettings(data) {
  return {
    type: ACTION_TYPES.RISK_FILTER_SETTINGS_RECEIVE,
    data: data
  };
};
export var failFilterSettings = function failFilterSettings() {
  return {
    type: ACTION_TYPES.RISK_FILTER_SETTINGS_FAIL
  };
};
export function fetchRiskFilterSettings(url) {
  return function (dispatch) {
    dispatch(requestFilterSettings());
    return fetch(url).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(receivedFilterSettings(json));
    })["catch"](function () {
      dispatch(failFilterSettings());
    });
  };
} // Save the Settings

export var requestSaveFilterSettings = function requestSaveFilterSettings() {
  return {
    type: ACTION_TYPES.RISK_FILTER_SETTINGS_SAVE_REQUEST
  };
};
export var savedFilterSettings = function savedFilterSettings(data) {
  return {
    type: ACTION_TYPES.RISK_FILTER_SETTINGS_SAVED,
    data: data
  };
};
export var saveFailFilterSettings = function saveFailFilterSettings() {
  return {
    type: ACTION_TYPES.RISK_FILTER_SETTINGS_SAVE_FAIL
  };
};
export function saveRiskFilterSettings(url, data) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'POST';
  return function (dispatch, getState) {
    dispatch(requestSaveFilterSettings());
    var formData = {
      risk_filter: _objectSpread({
        filter_settings: getState().riskFilterSettings.form
      }, data)
    };
    return fetch(url, {
      method: method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(_objectSpread({
        authenticity_token: window.CSRF
      }, formData))
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(savedFilterSettings(json));
    })["catch"](function () {
      dispatch(saveFailFilterSettings());
    });
  };
} // Form state

export var updateFormState = function updateFormState(data) {
  return {
    type: ACTION_TYPES.RISK_FILTER_SETTINGS_FORM_UPDATE,
    data: data
  };
}; // Search list

export var searchFiltersList = function searchFiltersList(data) {
  return {
    type: ACTION_TYPES.RISK_FILTER_SEARCH,
    data: data
  };
};